var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRating())?_c('div',{staticClass:"product-rating",on:{"click":_vm.scrollToRatings}},[_c('Rating',{attrs:{"rating":_vm.rating}}),_vm._v(" "),_c('label',[_vm._v("("+_vm._s(_vm.ratingsCount)+")")]),_vm._v(" "),_c('label',{staticClass:"mobile-text"},[_vm._v("("+_vm._s(_vm.ratingsCount)+")")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7f42e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductPage/ProductRating.vue
// module id = null
// module chunks = 